import {
  BatchCloneHorsesData,
  CloneHorseData,
  CreateHorseData,
  Horse,
  HorseActionSuccessTypeEnum,
} from '@sleipai/sleip-models';
import { createAction, props } from '@ngrx/store';
import { QueryConfig } from '../../helpers';
import { Update } from '@ngrx/entity';

export const loadHorses = createAction(
  '[Horses / API] Load Horses',
  props<{ uid: string }>()
);

export const loadConsumerHorses = createAction(
  '[Horses / API] Load Consumer Horses',
  props<{ uid: string }>()
);

export const loadSinglehorse = createAction(
  '[Horses / API] Load Single Horsess',
  props<{ horseId: string }>()
);

export const loadAdminHorses = createAction(
  '[Horses / API ] Load horses as admin'
);

export const loadHorsesByIds = createAction(
  '[Horses / API] Load Horses by horse Ids',
  props<{ horseIds: string[] }>()
);

export const addHorses = createAction(
  '[Horses / Store] Add Horses',
  props<{ horses: Partial<Horse>[] }>()
);

export const addSingleHorse = createAction(
  '[Horses / Store] Add single horse',
  props<{ horse: Partial<Horse> }>()
);

export const loadHorsesAssociatedUser = createAction(
  '[Horses / API] Load User Associated Horsess',
  props<{ uid: string }>()
);
// Update - Handle updates here :)

// * WHY *//
export const loadHorsessSuccess = createAction(
  '[Horses] Load Horsess Success',
  props<{ data: any }>()
);

export const loadHorsesFromAlgoliaSidbFailure = createAction(
  '[Horses] Load Horses From Algolia Sidb Failure',
  props<{ error: string }>()
);

export const loadHorsesForInfiniteScrollList = createAction(
  '[Horses] Load Horses For InfiniteScroll List',
  props<{ reset: boolean; queryConfig: QueryConfig }>()
);

export const loadHorsesForInfiniteScrollListSuccess = createAction(
  '[Horses] Load Horses For InfiniteScroll List Success',
  props<{
    horses: Horse[];
    hasMore: boolean;
  }>()
);

export const loadHorsesForInfiniteScrollListFailure = createAction(
  '[Horses] Load Horses For InfiniteScroll List Failure',
  props<{ error: string }>()
);

export const loadHorsesFailure = createAction(
  '[Horses] Load Horses Failure',
  props<{ error: any }>()
);

export const loadSharedHorses = createAction(
  '[Horses / API] Load shared horses',
  props<{ groupId: string }>()
);

export const loadHorsesFromAlgoliaSidb = createAction(
  '[Horses] Load Horses from Algolia Sidb',
  props<{
    queryConfig: QueryConfig;
    updateTotalCount: boolean;
  }>()
);

export const loadHorsesFromAlgoliaSidbSuccess = createAction(
  '[Horses] Load Horses from Algolia Sidb Success',
  props<{ data: any; updateTotalCount: boolean }>()
);

export const createHorseWithTags = createAction(
  '[Horses] Create Horse with tags',
  props<{ data: CreateHorseData }>()
);

export const saveHorseWithTagsSuccess = createAction(
  '[Horses] Save Horse with tags Success',
  props<{
    data: Partial<Horse>;
    horseActionSuccessType: HorseActionSuccessTypeEnum;
  }>()
);

export const saveHorseWithTagsFailure = createAction(
  '[Horses] Save Horse with tags Failure',
  props<{ error: any }>()
);

export const updateHorseWithTags = createAction(
  '[Horses] Update Horse with tags',
  props<{ data: Horse }>()
);

export const resetHorseSavedFlag = createAction(
  '[Horses] Reset Save Horse flag'
);

export const removeHorse = createAction(
  '[Horses] Remove Horse',
  props<{ horseToDelete: Horse }>()
);

export const removeHorseSuccess = createAction(
  '[Horses] Remove Horse Success',
  props<{
    horseId: string;
    horseActionSuccessType: HorseActionSuccessTypeEnum;
  }>()
);

export const horseDetailsActionFailure = createAction(
  '[Horses] Horse Details Action Failure',
  props<{ error: any }>()
);

export const resetRemoveHorseFlag = createAction(
  '[Horses] Reset Remove Horse Flag'
);

export const updateHorseName = createAction(
  '[Horses] Update Horse Name',
  props<{ horseToUpdate: Horse; name: string }>()
);

export const cloneHorse = createAction(
  '[Horses] Clone Horse',
  props<{ cloneHorse: CloneHorseData }>()
);

export const cloneHorseSuccess = createAction(
  '[Horses] Clone Horse Success',
  props<{
    horseActionSuccessType: HorseActionSuccessTypeEnum;
  }>()
);

export const horseUpdateSuccess = createAction(
  '[Horses] Horse Update Success',
  props<{
    update: Update<Horse>;
    horseActionSuccessType: HorseActionSuccessTypeEnum;
  }>()
);

export const batchStopShareHorse = createAction(
  '[Horses] Batch Stop Share Horse',
  props<{ uids: string[]; horseId: string }>()
);

export const batchStopShareHorseSuccess = createAction(
  '[Horses] Batch Stop Share Horse Success',
  props<{
    failedIds: string[];
    horseActionSuccessType: HorseActionSuccessTypeEnum;
  }>()
);

export const batchStopShareHorseFailure = createAction(
  '[Horses] Batch Stop Share Horse Failure',
  props<{ error: any }>()
);

export const mergeHorses = createAction(
  '[Horses] Merge Horses',
  props<{ horseIdToMerge: string; horseIdToMergeTo: string }>()
);

export const mergeHorsesSuccess = createAction(
  '[Horses] Merge Horses Success',
  props<{ horseIdToMerge: string; horseActionSuccessType: HorseActionSuccessTypeEnum }>()
);

export const batchDeleteHorses = createAction(
  '[Horses] Batch Delete Horses',
  props<{ ids: string[] }>()
);

export const batchDeleteHorsesSuccess = createAction(
  '[Horses] Batch Delete Horses Success',
  props<{ ids: string[]; failedIds: string[]; horseActionSuccessType: HorseActionSuccessTypeEnum }>()
);

export const batchDeleteHorsesFailure = createAction(
  '[Horses] Batch Delete Horses Failure',
  props<{ error: any }>()
);

export const batchCloneHorses = createAction(
  '[Horses] Batch Clone Horses',
  props<{ data: BatchCloneHorsesData }>()
);

export const batchCloneHorsesSuccess = createAction(
  '[Horses] Batch Clone Horses Success',
  props<{ failedIds: string[]; horseActionSuccessType: HorseActionSuccessTypeEnum }>()
);

export const batchCloneHorsesFailure = createAction(
  '[Horses] Batch Clone Horses Failure',
  props<{ error: any }>()
);
